import { StyledIcon } from './index.style'

export const VolumeControlIcon = ({ isMuted }: { isMuted: boolean }) => {
  return (
    <StyledIcon
      xmlns='http://www.w3.org/2000/svg'
      fill='none'
      viewBox='0 0 30 30'
    >
      <path
        className='st1'
        d='M15,0h0C23.3,0,30,6.7,30,15h0c0,8.3-6.7,15-15,15h0C6.7,30,0,23.3,0,15h0C0,6.7,6.7,0,15,0Z'
      />
      {isMuted ? (
        <g>
          <path
            className='st0'
            d='M7.8,9.2l2.8,2.8h-2.6c-.3,0-.5.1-.7.3-.2.2-.3.4-.3.7v4c0,.3.1.5.3.7.2.2.4.3.7.3h2.6l3.7,3.7c0,0,.2.2.3.2s.3,0,.4,0c.1,0,.3,0,.4,0,.2,0,.3-.2.5-.4.1-.2.2-.4.2-.6v-3.6l2.9,2.9c-.1,0-.2.1-.4.2-.1,0-.2.2-.3.3,0,.1,0,.3,0,.4s.2.2.3.3c.1,0,.3,0,.4,0,.2-.1.4-.2.7-.4l1.1,1.1.7-.7-13-13-.7.7ZM15,21l-3.9-3.9c0,0-.2-.1-.4-.1h-2.8v-4h2.8c0,0,.1,0,.2,0,0,0,.1,0,.2-.1h.1c0-.1,3.7,3.6,3.7,3.6v4.6Z'
          />
          <path
            className='st0'
            d='M18.4,9.3c.9.4,1.6,1,2.2,1.8.6.8,1,1.6,1.2,2.6.2.9.2,1.9,0,2.8-.2.9-.7,1.8-1.3,2.5l.7.7c.7-.8,1.3-1.8,1.6-2.9.3-1.1.3-2.2,0-3.3-.2-1.1-.7-2.1-1.4-3-.7-.9-1.6-1.6-2.6-2.1,0,0-.1,0-.2,0,0,0-.1,0-.2,0,0,0-.1,0-.2,0,0,0,0,0-.1.2s0,.1,0,.2c0,0,0,.1,0,.2,0,0,0,.1.1.2,0,0,.1,0,.2.1h0Z'
          />
          <path
            className='st0'
            d='M17.3,12.3c.5.3.9.7,1.1,1.1.3.5.4,1,.4,1.6,0,.7-.2,1.3-.6,1.9l.7.7c.6-.7.9-1.6.9-2.6,0-.7-.2-1.4-.6-2-.4-.6-.9-1.1-1.5-1.5,0,0-.1,0-.2,0,0,0-.1,0-.2,0,0,0-.1,0-.2,0,0,0,0,0-.1.1,0,0,0,.1,0,.2,0,0,0,.1,0,.2,0,0,0,.1,0,.2,0,0,0,0,.2.1h0Z'
          />
          <path
            className='st0'
            d='M15,9v4.6l1,1v-5.6c0-.2,0-.4-.2-.6s-.3-.3-.4-.4c-.2,0-.4,0-.6,0-.2,0-.4.1-.5.3l-2.3,2.3.7.7,2.3-2.3Z'
          />
        </g>
      ) : (
        <g>
          <path
            className='st0'
            d='M17.7,18.6c-.1,0-.2,0-.3,0s-.2-.2-.2-.3c0-.1,0-.2,0-.3,0-.1.1-.2.2-.2.5-.3.8-.7,1.1-1.2.3-.5.4-1,.4-1.5,0-.5-.2-1.1-.4-1.5s-.7-.8-1.1-1.1c0,0-.1,0-.2-.1,0,0,0-.1,0-.2,0,0,0-.1,0-.2,0,0,0-.1,0-.2,0,0,0-.1.1-.1,0,0,.1,0,.2,0,0,0,.1,0,.2,0,0,0,.1,0,.2,0,.6.4,1.1.9,1.5,1.5.4.6.6,1.3.6,2,0,.7-.2,1.4-.5,2-.3.6-.8,1.1-1.4,1.5,0,0-.2,0-.3,0Z'
          />
          <path
            className='st0'
            d='M18.8,21.6c-.1,0-.2,0-.3-.1,0,0-.1-.2-.2-.3,0-.1,0-.2,0-.3s.1-.2.2-.2c1-.5,1.9-1.3,2.5-2.3.6-1,.9-2.1.9-3.3,0-1.2-.3-2.3-1-3.3s-1.5-1.8-2.6-2.3c0,0-.1,0-.2-.1s0-.1-.1-.2c0,0,0-.1,0-.2,0,0,0-.1,0-.2,0,0,0-.1.1-.2,0,0,.1,0,.2,0,0,0,.1,0,.2,0,0,0,.1,0,.2,0,1.2.6,2.3,1.5,3,2.6.7,1.1,1.1,2.5,1.1,3.8,0,1.4-.4,2.7-1.1,3.8-.7,1.2-1.7,2.1-2.9,2.7,0,0-.2,0-.2,0Z'
          />
          <path
            className='st0'
            d='M15,22c-.1,0-.3,0-.4,0-.1,0-.2-.1-.3-.2l-3.7-3.7h-2.6c-.3,0-.5-.1-.7-.3-.2-.2-.3-.4-.3-.7v-4c0-.3.1-.5.3-.7.2-.2.4-.3.7-.3h2.6l3.7-3.7c.1-.1.3-.2.5-.3.2,0,.4,0,.6,0s.3.2.5.4c.1.2.2.4.2.6v12c0,.2,0,.4-.2.6-.1.2-.3.3-.5.4-.1,0-.2,0-.4.1ZM8,13v4h2.8c0,0,.1,0,.2,0,0,0,.1,0,.2.1l3.9,3.9v-12l-3.8,3.9s-.1,0-.2.1c0,0-.1,0-.2,0h-2.8Z'
          />
        </g>
      )}
    </StyledIcon>
  )
}
